// frontend/src/features/ogdb2/pages/ImportWizardPage.jsx
import React from "react";
import ImportExportPanel from "../components/ImportExportPanel";

export default function ImportWizardPage({ onRefresh, onGoAnalysis }) {
  return (
    <div className="space-y-4">
      <ImportExportPanel onRefresh={onRefresh} />
    </div>
  );
}
